export default "__VITE_ASSET__5f85e029__"